export function mapQuotationTypeSlug(type: string) {
    if (type === 'all') {
        return 'draft,waiting_for_customer,closed';
    }
    return type;
}
